import type {
  ApprovalInboxNotification,
  InboxNotification,
  MentionNotification,
} from "@/app/components/MentionInboxPopover";

export type InboxNotificationStatePatch = {
  is_read?: boolean;
  is_archived?: boolean;
  read_at?: string | null;
};

export const isInboxNotification = (value: unknown): value is InboxNotification => {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as Partial<InboxNotification> & { notification_type?: unknown };
  return candidate.notification_type === "mention" || candidate.notification_type === "approval";
};

export const applyInboxNotificationPatch = (
  notification: InboxNotification,
  patch: InboxNotificationStatePatch,
): InboxNotification => {
  if (notification.notification_type === "mention") {
    const next: MentionNotification = { ...notification, ...patch };
    return next;
  }

  const next: ApprovalInboxNotification = { ...notification, ...patch };
  return next;
};
